<div class="container">
  <nz-tabset (nzSelectChange)="changeTab($event)" [nzSelectedIndex]="0">
    <nz-tab nzTitle="Thông tin quỹ">
      <app-edit-fund [hidden]="tab !== TABS.EDIT_FUND"></app-edit-fund >
    </nz-tab>
    <nz-tab nzTitle="Tài liệu Quỹ">
      <div class="d-md-flex flex-column" *ngIf="tab === TABS.UPLOAD_FILE">
        <div class="d-flex justify-content-end mb-4">
          <button nz-button nzType="primary" class="admin-btn_create" (click)="openPopupUpload()">Import</button>
        </div>
        <app-document-files-for-fund [id]="id" [typeCode]="'PROSPECTUS_FUND'" [hidden]="!id"></app-document-files-for-fund>
        <app-document-files-for-fund [id]="id" [typeCode]="'SUMMARY_PROSPECTUS_FUND'" [hidden]="!id"></app-document-files-for-fund>
        <app-document-files-for-fund [id]="id" [typeCode]="'REGULATION_FUND'" [hidden]="!id"></app-document-files-for-fund>
      </div>
    </nz-tab>
  </nz-tabset>
  <div class="tabs">
    <div class="tab-1">
     
    </div>
    <div class="tab-2">
      
    </div>
  </div>
</div>
